import { Injectable } from '@angular/core';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { ControllerType, HttpClientService } from '../http-client.service';

@Injectable({
  providedIn: 'root'
})
export class WarehouseService {

  constructor(private httpClientService:HttpClientService) { }

  async getAllWarehouses(page,size,search){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Warehouse,
      queryString:`Page=${page}&Size=${size}&search=${search}`
    });
    return await firstValueFrom(observable);
  }

  async getByIdWarehouseDetail(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Warehouse,
      action:"GetByIdWarehouseDetail"
    },id);
    return await firstValueFrom(observable);
  }

  async updateWarehouses(id,name){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.Warehouse,
    },{
      id:id,
      warehouseName:name
    });
    return await firstValueFrom(observable);
  }

  async createWarehouses(name){
    const observable:Observable<any> = this.httpClientService.post({
      controller:ControllerType.Warehouse,
    },{
      warehouseName:name
    });
    return await firstValueFrom(observable);
  }
  
  private eventSubject = new Subject<boolean>();
  
  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
